import axios from 'axios';

// Configurable via REACT_APP_API_URL en .env
const API_URL =
    process.env.REACT_APP_API_URL ||
    'https://sinca.mma.gob.cl/index.php/json/listadomapa2k19/';

export const fetchStations = (signal) =>
    axios
        .get(API_URL, { timeout: 10000, signal })
        .then(res => {
            if (!Array.isArray(res.data)) {
                throw new Error('La API devolvió un formato inesperado');
            }
            return res.data;
        });
